import apiClient from "./api"

// Banner Interfaces
export interface Banner {
    _id: string
    title: string
    description?: string
    imageUrl: string
    targetUrl?: string
    placement: "home" | "restaurant" | "checkout" | "profile"
    isActive: boolean
    startDate: string
    endDate: string
    priority: number
    createdAt: string
    updatedAt: string
}

export interface CreateBannerDTO {
    title: string
    description?: string
    imageUrl: string
    targetUrl?: string
    placement: "home" | "restaurant" | "checkout" | "profile"
    isActive: boolean
    startDate: string
    endDate: string
    priority?: number
}

// Push Notification Interfaces
export interface PushNotification {
    _id: string
    title: string
    body: string
    targetAudience: "all_users" | "all_drivers" | "all_restaurants" | "specific_user"
    targetUserId?: string
    imageUrl?: string
    actionUrl?: string
    sentAt: string
    sentBy: {
        _id: string
        username: string
    }
    recipientCount: number
    deliveredCount: number
    clickedCount: number
}

export interface SendNotificationDTO {
    title: string
    body: string
    targetAudience: "all_users" | "all_drivers" | "all_restaurants" | "specific_user"
    targetUserId?: string
    imageUrl?: string
    actionUrl?: string
}

// Banner API
export const bannerAPI = {
    getBanners: (params?: { placement?: string; isActive?: boolean }) =>
        apiClient.get("/admin/banners", { params }),

    getBannerById: (id: string) =>
        apiClient.get(`/admin/banners/${id}`),

    createBanner: (data: CreateBannerDTO) =>
        apiClient.post("/admin/banners", data),

    updateBanner: (id: string, data: Partial<CreateBannerDTO>) =>
        apiClient.put(`/admin/banners/${id}`, data),

    deleteBanner: (id: string) =>
        apiClient.delete(`/admin/banners/${id}`),

    toggleBannerStatus: (id: string, isActive: boolean) =>
        apiClient.patch(`/admin/banners/${id}/toggle`, { isActive }),

    uploadBannerImage: (file: File) => {
        const formData = new FormData()
        formData.append("image", file)
        return apiClient.post("/admin/banners/upload", formData, {
            headers: { "Content-Type": "multipart/form-data" }
        })
    }
}

// Push Notification API
export const notificationAPI = {
    getNotifications: (params?: { page?: number; limit?: number }) =>
        apiClient.get("/admin/notifications", { params }),

    getNotificationById: (id: string) =>
        apiClient.get(`/admin/notifications/${id}`),

    sendNotification: (data: SendNotificationDTO) =>
        apiClient.post("/admin/notifications/send", data),

    getNotificationStats: () =>
        apiClient.get("/admin/notifications/stats")
}
